import React from 'react';
import { SxProp, View } from 'dripsy';

import { TextBody, TextCaption } from '@/design-system/components/typography';
import { UniSwitch } from '@/design-system/components/inputs';
import { useTranslation } from 'react-i18next';

export interface AutoRenewalSwitchProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  sx?: SxProp;
}

export const AutoRenewalSwitch: React.FC<AutoRenewalSwitchProps> = (props) => {
  const { t } = useTranslation('earn');
  const { value, onValueChange, disabled = false, sx } = props;

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <View sx={styles.textContainer}>
        <TextBody label>{t('earn-invest::glossary.auto-renewal')}</TextBody>
        <TextCaption secondary>{t('earn-invest::glossary.auto-description')}</TextCaption>
      </View>
      <View sx={styles.switchContainer}>
        <UniSwitch value={value} onValueChange={onValueChange} disabled={disabled} />
      </View>
    </View>
  );
};

enum StyleName {
  container = 'container',
  textContainer = 'textContainer',
  switchContainer = 'switchContainer'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    marginBottom: '$5',
    paddingY: '$3',
    borderTopWidth: 1,
    borderTopColor: '$borderPrimary',
    borderBottomWidth: 1,
    borderBottomColor: '$borderPrimary',
    flexDirection: 'row'
  },
  textContainer: {
    flex: 1
  },
  switchContainer: {
    ml: '$5',
    flexDirection: 'row',
    alignItems: 'center'
  }
};
